import { v4 as uuidv4 } from "uuid";

export type Json = Record<string, unknown>;

export function createId() {
    return uuidv4().replace(/-/g, "");
}
